<template>
  <div>
    <global-confirm-box ref="confirmBox"></global-confirm-box>

    <page-header
      icon="mdi-account-group"
      :title="$t('users') + ' - ' + $t('guest')"
      :subtitle="$t('manage_guest_users')"
    />

    <page-toolbar
      v-model="search"
      :search-placeholder="$t('search_guest_users_placeholder')"
    >
    </page-toolbar>

    <div class="px-6 mt-2">
      <v-data-table
        :headers="headers"
        :items="customSearch(translatedGuestUsers, headers, search, ['lastname', 'email'])"
        sort-by="name"
        class="ordera-box-shadow striped-table"
        mobile-breakpoint="0"
      >
        <template v-slot:top>
          <v-divider></v-divider>
        </template>
        <template v-slot:item.name="{ item }">
          <div class="py-2">
            <div class="font-weight-medium">
              {{ toLatin([item.name, item.lastname].join(" ")) }}
            </div>
            <div v-if="item.email" class="text-caption grey--text">
              {{ item.email }}
            </div>
          </div>
        </template>
        <template v-slot:item.city_name="{ item }">
          {{ item.city_name }}
        </template>
        <template v-slot:item.state="{ item, index }">
          <span v-if="item.state == 1">
            <span class="success" style="border-radius: 30px; padding: 0 10px"> </span>
          </span>
          <span v-if="item.state == 0">
            <span class="error" style="border-radius: 30px; padding: 0 10px"></span>
          </span>
        </template>
        <template v-slot:item.created_at="{ item, index }">
          {{ formatDateTime(item.created_at) }}
        </template>
        <template v-slot:item.actions="{ item, index }">
          <v-row no-gutters justify="end">
            <circle-button
              class="mr-2"
              icon="mdi-qrcode-scan"
              @click="close2(item, index)"
              :tooltip="$t('tooltip_scan_guest_qr')"
            />
            <edit-button class="mr-2" @click="openDialog(item, index)"></edit-button>
            <remove-button @click="openDialogDelete(item, index)"></remove-button>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <global-dialog-card
      v-model="dialog"
      :title="[editedItem.name, editedItem.lastname].join(' ')"
    >
      <v-container>
        <v-row class="mt-3">
          <v-col cols="12">
            <v-switch
              v-model="editedItem.state"
              inset
              :label="$t('active')"
              :false-value="0"
              :true-value="1"
              dense
            ></v-switch>
          </v-col>
          <v-spacer></v-spacer>
          <v-row>
            <v-col cols="6">
              <text-field
                v-model="editedItem.name"
                :rules="[$t('required_field')]"
                :label="$t('name')"
              />
            </v-col>
            <v-col cols="6">
              <text-field
                v-model="editedItem.lastname"
                :rules="[$t('required_field')]"
                :label="$t('last_name')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <text-field
                v-model="editedItem.email"
                :rules="[$t('required_field')]"
                :label="$t('email_or_username')"
              />
            </v-col>
            <v-col cols="6">
              <text-field
                v-model="editedItem.private_email"
                :label="$t('private_email')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <text-field
                v-model="editedItem.password"
                :rules="[$t('required_field')]"
                :label="$t('password')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <text-field v-model="editedItem.address" :label="$t('address')" />
            </v-col>
            <v-col cols="6">
              <text-field v-model="editedItem.phone" :label="$t('phone')" />
            </v-col>
          </v-row>
        </v-row>
      </v-container>
      <template #actions>
        <v-btn text @click="close">
          {{ $t("cancel") }}
        </v-btn>
        <primary-button @click="save">{{ $t("edit") }}</primary-button>
      </template>
    </global-dialog-card>
    <global-dialog-card
      v-model="dialog2"
      :max-width="500"
      :title="$t('qr_code')"
      hide-actions
    >
      <v-row justify="center" class="mt-2">
        <v-col cols="5">
          <qrcode-vue
            id="qrkodstampa"
            :value="
              JSON.stringify({
                id: this.selectedQr,
                secure: this.selectedQrSecret,
              })
            "
            :size="160"
            level="H"
            render-as="svg"
        /></v-col>
        <v-col cols="7">
          <div
            style="
              color: rgba(0, 0, 0, 0.87) !important;
              font-weight: 900;
              margin-left: -15px;
            "
            class="p-3"
          >
            <div>ID: {{ editedItem.id }}</div>
            <div>
              {{ toLatin(editedItem.name) + " " + toLatin(editedItem.lastname) }}
            </div>
            <div>{{ editedItem.email }}</div>
          </div>
        </v-col>
      </v-row>
    </global-dialog-card>
  </div>
</template>

<script>
import moment from "moment";
import QrcodeVue from "qrcode.vue";
import hasSnackbar from "@/mixins/hasSnackbar";
import userService from "@/services/user";
export default {
  mixins: [hasSnackbar],
  components: { QrcodeVue },
  data() {
    return {
      windowSize: {
        x: 0,
        y: 0,
      },
      selectedQrSecret: "",
      selectedQr: "",
      qrIndex: "",
      dialog2: false,
      search: "",
      editedItem: "",
      editedIndex: "",
      dialog: false,
      deleteItem: false,
      itemIndex: "",
      guestUsers: [],
    };
  },
  created() {
    this.getAllGests();
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    close2(item, index) {
      this.editedIndex = this.guestUsers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      userService
        .getUserHash(this.editedItem.id)
        .then((res) => {
          this.selectedQrSecret = res.data;
          this.selectedQr = this.editedItem.id;
          this.qrIndex = index;
          this.dialog2 = !this.dialog2;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_qr_code"));
        });
    },
    openDialogDelete(item, index) {
      this.deleteItem = item;
      this.itemIndex = index;

      this.$refs.confirmBox
        .open(
          this.$t("delete_confirmation"),
          `${this.$t("confirm_delete_user")}: ${this.toLatin(item.name)} ${this.toLatin(
            item.lastname
          )}?`,
          {
            color: "error",
          }
        )
        .then(() => {
          this.deleteItemConfirm();
        })
        .catch((err) => console.warn(err));
    },
    deleteItemConfirm() {
      userService
        .deleteGuestUser(this.deleteItem, this.itemIndex)
        .then(({ data }) => {
          if (data) {
            this.guestUsers.filter((item, index) => {
              if (item.id == this.deleteItem.id) {
                this.guestUsers.splice(index);
              }
            });
            this.getAllGests();
            this.showSuccessSnackbar(this.$t("deleted_successfully"));
            // Reset delete item reference
            this.deleteItem = false;
            this.itemIndex = "";
          }
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_deleting_user"));
        });
      this.$forceUpdate();
    },
    save() {
      userService
        .editGuestUser(this.editedItem, this.itemIndex)
        .then(({ data }) => {
          if (data) {
            this.guestUsers.filter((item) => {
              if (item.id == data.data.id) {
                item = data.data;
              }
            });
            this.showSuccessSnackbar(this.$t("saved_successfully"));
            this.dialog = false;
          }
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_saving_user"));
        });
    },
    close() {
      this.dialog = false;
    },
    openDialog(item) {
      this.dialog = true;
      this.editedItem = item;
    },
    getAllGests() {
      userService
        .getAllGuestUsers()
        .then(({ data }) => {
          this.guestUsers = data.users;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_users"));
        });
    },
    formatDateTime(date) {
      return moment(date).format("DD.MM.YYYY hh:mm");
    },
  },
  computed: {
    translatedGuestUsers() {
      return this.guestUsers.map((item) => ({
        ...item,
        city_name: item.orders_guest?.length
          ? item.orders_guest[0].location
            ? this.toLatin(item.orders_guest[0].location.city.name)
            : ""
          : "",
      }));
    },
    headers() {
      return [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        {
          text: this.$t("name"),
          align: "start",
          value: "name",
          sortable: true,
        },
        {
          text: this.$t("city"),
          align: "start",
          value: "city_name",
          sortable: true,
        },
        {
          text: this.$t("phone"),
          align: "start",
          value: "phone",
          sortable: true,
        },
        {
          text: this.$t("status"),
          align: "start",
          value: "state",
          sortable: true,
        },
        {
          text: this.$t("active"),
          align: "start",
          value: "created_at",
          sortable: true,
        },
        {
          text: this.$t("ordered"),
          align: "start",
          value: "orders_guest_count",
          sortable: true,
        },
        {
          text: this.$t("actions"),
          align: "end",
          value: "actions",
          sortable: true,
        },
      ];
    },
    backGround() {
      if (this.$store.state.restaurant) {
        return this.$store.state.restaurant.settings
          ? this.$store.state.restaurant.settings.topbar.background
          : "primary";
      } else {
        return this.$store.state.company?.settings?.topbar?.background || "primary";
      }
    },
  },
};
</script>
